export default "__VITE_ASSET__HG_dP4b0__"